import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import AvatarStack from '@alltrails/shared/denali/components/AvatarStack';
import LoadingSpinner from '@alltrails/shared/components/LoadingSpinner';
import ModalBackground from '@alltrails/shared/components/modals/ModalBackground';
import CustomProvider from 'components/CustomProvider';
import logError from 'utils/logError';
import getFollowUserRequest from '../../api/User';

import * as styles from './styles/styles.module.scss';

type User = {
  id: number;
  first_name: string;
  last_name: string;
  slug: string;
};

type Users = {
  user: User;
};

type Props = {
  name: string;
  count: number;
  users: Users[];
  linkPath: string;
};

const AvatarStackContainer = ({ name, count, users, linkPath }: Props): JSX.Element => {
  const [showModal, setShowModal] = useState(false);
  const [modalComponent, setShowModalComponent] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const avatars = users.map(user => ({
    userId: user.user.id,
    userName: `${user.user.first_name} ${user.user.last_name}`,
    linkInfo: {
      href: `/members/${user.user.slug}`
    },
    onClick: () => {}
  }));

  const onOverflowClick = () => {
    setShowModal(true);
    setIsLoading(true);
    getFollowUserRequest(linkPath)
      .then((response: any) => {
        setIsLoading(false);
        setShowModalComponent(response);
      })
      .catch((err: any) => {
        setIsLoading(false);
        setShowModal(false);
        logError(err);
      });
  };

  return (
    <CustomProvider>
      <div className={styles.avatarStack}>
        <div className={styles.header}>
          <span className={styles.title}>
            {name === 'following' ? <FormattedMessage defaultMessage="Following" /> : <FormattedMessage defaultMessage="Followers" />}
          </span>
          <span className={styles.count}>{count}</span>
        </div>
        <AvatarStack avatars={avatars} onClick={onOverflowClick} testId="avatars" />
        {showModal && (
          <ModalBackground closeModal={() => setShowModal(false)}>
            {isLoading ? <LoadingSpinner /> : <div className={styles.modalWrapper} dangerouslySetInnerHTML={{ __html: modalComponent }} />}
          </ModalBackground>
        )}
      </div>
    </CustomProvider>
  );
};

export default AvatarStackContainer;
